import React from "react";
import axios from "axios";
import CreatableSelect from 'react-select/creatable';
import Select from 'react-select';
import ShowReport from "./ShowReport";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Swal from "sweetalert2";
import { sumMoney, round2, formatAmount } from "../../../helper";

const steps = [
    "Setup Device",
    "Services",
    "Appointment",
    "Your Details"
];

const ServiceTypeOption = [
    { value: 'Express', label: 'Express' },
    { value: 'Premium', label: 'Premium' }
];

const RepairTypeList = [
    { value: 'Phone', label: 'Phone' },
    { value: 'Tablet', label: 'Tablet' },
    { value: 'Laptop', label: 'Laptop' },
    { value: 'Gaming Console', label: 'Gaming Console' },
];

function subtotal(items) {
    return sumMoney(items, "PC_REP_CURR_COST");
}

const darkSelect = {
    control: (base, state) => ({
        ...base,
        background: 'rgba(255,255,255,0.06)',
        border: state.isFocused ? '1px solid rgba(198,21,21,0.6)' : '1px solid rgba(255,255,255,0.1)',
        borderRadius: '10px',
        boxShadow: state.isFocused ? '0 0 0 3px rgba(198,21,21,0.1)' : 'none',
        minHeight: '44px',
        cursor: 'pointer',
        '&:hover': { borderColor: 'rgba(198,21,21,0.35)' },
    }),
    menu: (base) => ({
        ...base,
        background: '#161616',
        border: '1px solid rgba(255,255,255,0.08)',
        borderRadius: '10px',
        overflow: 'hidden',
    }),
    menuList: (base) => ({ ...base, padding: '4px' }),
    option: (base, { isSelected, isFocused }) => ({
        ...base,
        background: isSelected ? '#c61515' : isFocused ? 'rgba(198,21,21,0.15)' : 'transparent',
        color: 'white',
        cursor: 'pointer',
        fontSize: '14px',
        borderRadius: '6px',
    }),
    singleValue: (base) => ({ ...base, color: 'white', fontSize: '14px' }),
    input: (base) => ({ ...base, color: 'white' }),
    placeholder: (base) => ({ ...base, color: '#3a3a3a', fontSize: '14px' }),
    indicatorSeparator: () => ({ display: 'none' }),
    dropdownIndicator: (base) => ({ ...base, color: '#444' }),
};

const portalSelect = {
    ...darkSelect,
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

const lbl = {
    display: 'block',
    color: '#777',
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '1.5px',
    textTransform: 'uppercase',
    marginBottom: '8px',
};

const inp = {
    background: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: '10px',
    color: 'white',
    padding: '11px 14px',
    fontSize: '14px',
    fontFamily: 'Catamaran, sans-serif',
    width: '100%',
    boxSizing: 'border-box',
    outline: 'none',
    colorScheme: 'dark',
};

class RepairBlock extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeStep: 0,
            RepairModelList: [],
            RepairBrandList: [],
            RepairServiceList: [],
            RepairShopList: [],
            AllServiceData: [],
            TempNotes: [],
            jobData: {
                PC_REP_ID: "",
                PC_REP_BARCODE: "",
                PC_REP_TYPE: "",
                PC_REP_MODEL: "",
                PC_REP_BRAND: "",
                PC_REP_IMSR: "",
                PC_REP_OTHER_INFO: "",
                PC_REP_LIST: [],
                PC_REP_TOTAL_COST: "0",
                PC_REP_DEP_TYPE: "Cash",
                PC_REP_DEP: "0",
                PC_REP_DEP_DATE: "",
                PC_REP_REM_AM_TYPE: "Cash",
                PC_REP_REM_AM: "0",
                PC_REP_REM_AM_DATE: "",
                PC_REP_REM_BAL: "0",
                PC_REP_SHOP: "",
                PC_REP_STATUS: "",
                PC_REP_DATA_TYPE: "",
                PC_REP_NOTES: [],
                PC_REP_APP_DATE: "",
                PC_REP_APP_TIME: "",
                PC_CUST_FR_NAME: "",
                PC_CUST_LT_NAME: "",
                PC_CUST_PHONE: "",
                PC_CUST_EMAIL: "",
                PC_CUST_HSST_NO: "",
                PC_CUST_POST_CODE: "",
                PC_CUST_ADD_INFO: "",
                PC_REP_CREATED_DATE: "",
                PC_REP_UPDATED_DATE: ""
            },
            enableReport: false
        };
    }

    componentDidMount() {
        this.getShopList();
    }

    async getShopList() {
        const getShops = await axios.get(`${process.env.REACT_APP_BASE_URL}services/query/PCGetShops.php`);
        let shopData = getShops.data;
        let RepairShopList = [];
        if (shopData.success === 1) {
            for (let i = 0; i < shopData.data.length; i++) {
                const shop = shopData.data[i];
                RepairShopList.push({ value: shop.SP_NAME, label: shop.SP_NAME });
            }
        }
        this.setState({ RepairShopList });
    }

    validateForm() {
        let { jobData } = this.state;
        if (jobData.PC_REP_TYPE === '') {
            Swal.fire('Error', 'Please Select Device Type', 'error');
            return false;
        }
        if (jobData.PC_REP_MODEL === '') {
            Swal.fire('Error', 'Please Select Brand', 'error');
            return false;
        }
        if (jobData.PC_REP_BRAND === '') {
            Swal.fire('Error', 'Please Select Model', 'error');
            return false;
        }
        if (jobData.PC_REP_LIST.length === 0) {
            Swal.fire('Error', 'Please Enter Any Repair', 'error');
            return false;
        }
        if (
            jobData.PC_CUST_FR_NAME === '' ||
            jobData.PC_CUST_LT_NAME === '' ||
            jobData.PC_CUST_PHONE === '' ||
            jobData.PC_CUST_EMAIL === '' ||
            jobData.PC_CUST_HSST_NO === '' ||
            jobData.PC_CUST_POST_CODE === ''
        ) {
            Swal.fire('Error', 'Please Enter Complete Customer Information', 'error');
            return false;
        }
        return true;
    }

    async handleNextStep() {
        let { jobData, activeStep } = this.state;
        let RepairServiceList = [];
        if (activeStep === 0) {
            let formData = {
                REPAIR_TYPE: jobData.PC_REP_TYPE?.value,
                REPAIR_BRAND: jobData.PC_REP_MODEL?.value,
                REPAIR_DEVICE: jobData.PC_REP_BRAND?.value,
                PC_SHOP: jobData.PC_REP_SHOP?.value
            };
            const getService = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/PCGetShopService.php`, formData);
            let serv = getService.data;
            if (serv.success === 1) {
                for (let i = 0; i < serv.data.length; i++) {
                    const ele = serv.data[i];
                    if (
                        ele.PCSS_DEVICE_TYPE === jobData['PC_REP_TYPE']?.value &&
                        ele.PCSS_DEVICE_BRAND === jobData['PC_REP_MODEL']?.value &&
                        ele.PCSS_DEVICE_NAME === jobData['PC_REP_BRAND']?.value
                    ) {
                        RepairServiceList.push({ value: ele.PCSS_SERVICE, label: ele.PCSS_SERVICE });
                    }
                }
            }
            jobData['PC_REP_IMSR'] = "";
            jobData['PC_REP_LIST'] = [];
            this.setState({ RepairServiceList, AllServiceData: serv.data });
        }

        if (activeStep === 3) {
            if (!this.validateForm()) return;
            let formData = {
                PC_REP_ID: jobData.PC_REP_ID,
                PC_REP_TYPE: JSON.stringify(jobData.PC_REP_TYPE),
                PC_REP_MODEL: JSON.stringify(jobData.PC_REP_MODEL),
                PC_REP_BRAND: JSON.stringify(jobData.PC_REP_BRAND),
                PC_REP_IMSR: jobData.PC_REP_IMSR,
                PC_REP_OTHER_INFO: jobData.PC_REP_OTHER_INFO,
                PC_REP_LIST: JSON.stringify(jobData.PC_REP_LIST),
                PC_REP_TOTAL_COST: jobData.PC_REP_TOTAL_COST,
                PC_REP_DEP_TYPE: jobData.PC_REP_DEP_TYPE,
                PC_REP_DEP: jobData.PC_REP_DEP,
                PC_REP_DEP_DATE: new Date().toLocaleDateString(),
                PC_REP_REM_AM_TYPE: jobData.PC_REP_REM_AM_TYPE,
                PC_REP_REM_AM: jobData.PC_REP_REM_AM,
                PC_REP_REM_AM_DATE: new Date().toLocaleDateString(),
                PC_REP_REM_BAL: jobData.PC_REP_REM_BAL,
                PC_REP_SHOP: jobData.PC_REP_SHOP.value,
                PC_REP_STATUS: 'Request',
                PC_REP_DATA_TYPE: 'Online Customer',
                PC_REP_NOTES: JSON.stringify([...jobData.PC_REP_NOTES, ...this.state.TempNotes]),
                PC_REP_APP_DATE: jobData.PC_REP_APP_DATE,
                PC_REP_APP_TIME: jobData.PC_REP_APP_TIME,
                PC_CUST_FR_NAME: jobData.PC_CUST_FR_NAME,
                PC_CUST_LT_NAME: jobData.PC_CUST_LT_NAME,
                PC_CUST_PHONE: jobData.PC_CUST_PHONE,
                PC_CUST_EMAIL: jobData.PC_CUST_EMAIL,
                PC_CUST_HSST_NO: jobData.PC_CUST_HSST_NO,
                PC_CUST_POST_CODE: jobData.PC_CUST_POST_CODE,
                PC_CUST_ADD_INFO: jobData.PC_CUST_ADD_INFO
            };
            const addNewRepairRequest = await axios.post(`${process.env.REACT_APP_BASE_URL}services/mutation/PCJob.php`, formData);
            if (addNewRepairRequest.data.success === 1) {
                this.setState({ enableReport: true });
            }
        } else {
            this.setState({ activeStep: activeStep + 1 });
        }
    }

    handleBackStep() {
        this.setState({ activeStep: this.state.activeStep - 1 });
    }

    handleRequestMore() {
        this.setState({
            activeStep: 0,
            RepairModelList: [],
            RepairBrandList: [],
            RepairServiceList: [],
            RepairShopList: [],
            AllServiceData: [],
            TempNotes: [],
            jobData: {
                PC_REP_ID: "", PC_REP_BARCODE: "", PC_REP_TYPE: "", PC_REP_MODEL: "",
                PC_REP_BRAND: "", PC_REP_IMSR: "", PC_REP_OTHER_INFO: "", PC_REP_LIST: [],
                PC_REP_TOTAL_COST: "0", PC_REP_DEP_TYPE: "Cash", PC_REP_DEP: "0",
                PC_REP_DEP_DATE: "", PC_REP_REM_AM_TYPE: "Cash", PC_REP_REM_AM: "0",
                PC_REP_REM_AM_DATE: "", PC_REP_REM_BAL: "0", PC_REP_SHOP: "",
                PC_REP_STATUS: "", PC_REP_DATA_TYPE: "", PC_REP_NOTES: [],
                PC_REP_APP_DATE: "", PC_REP_APP_TIME: "", PC_CUST_FR_NAME: "",
                PC_CUST_LT_NAME: "", PC_CUST_PHONE: "", PC_CUST_EMAIL: "",
                PC_CUST_HSST_NO: "", PC_CUST_POST_CODE: "", PC_CUST_ADD_INFO: "",
                PC_REP_CREATED_DATE: "", PC_REP_UPDATED_DATE: ""
            },
            enableReport: false
        });
    }

    handleAddService() {
        let { jobData } = this.state;
        jobData['PC_REP_LIST'].push({
            PC_REP_PROB: "",
            PC_REP_SER_TYPE: { value: 'Express', label: 'Express' },
            PC_REP_EST_COST: 0,
            PC_REP_DISCOUNT: 0,
            PC_REP_CURR_COST: 0
        });
        this.setState({ jobData });
    }

    handleChangeServices(indx, fieldName, evnt) {
        let { AllServiceData, jobData } = this.state;
        let myPercentage, myBalance, fakeBalance;
        switch (fieldName) {
            case 'PC_REP_PROB':
                jobData['PC_REP_LIST'][indx][fieldName] = evnt;
                jobData['PC_REP_LIST'][indx]['PC_REP_DISCOUNT'] = 0;
                if (AllServiceData) {
                    for (let i = 0; i < AllServiceData.length; i++) {
                        const servData = AllServiceData[i];
                        if (servData?.PCSS_SERVICE === evnt?.value) {
                            if (jobData['PC_REP_LIST'][indx]['PC_REP_SER_TYPE']?.value === 'Express') {
                                jobData['PC_REP_LIST'][indx]['PC_REP_EST_COST'] = +servData.PCSS_SERVICE_COST;
                                jobData['PC_REP_LIST'][indx]['PC_REP_CURR_COST'] = +servData.PCSS_SERVICE_COST;
                            } else {
                                jobData['PC_REP_LIST'][indx]['PC_REP_EST_COST'] = +servData.PCSS_SERVICE_PREM;
                                jobData['PC_REP_LIST'][indx]['PC_REP_CURR_COST'] = +servData.PCSS_SERVICE_PREM;
                            }
                        }
                    }
                }
                break;
            case 'PC_REP_SER_TYPE':
                jobData['PC_REP_LIST'][indx][fieldName] = evnt;
                jobData['PC_REP_LIST'][indx]['PC_REP_DISCOUNT'] = 0;
                if (AllServiceData) {
                    for (let i = 0; i < AllServiceData.length; i++) {
                        const servData = AllServiceData[i];
                        if (servData?.PCSS_SERVICE === jobData['PC_REP_LIST'][indx]['PC_REP_PROB']?.value) {
                            if (evnt?.value === 'Express') {
                                jobData['PC_REP_LIST'][indx]['PC_REP_EST_COST'] = +servData.PCSS_SERVICE_COST;
                                jobData['PC_REP_LIST'][indx]['PC_REP_CURR_COST'] = +servData.PCSS_SERVICE_COST;
                            } else {
                                jobData['PC_REP_LIST'][indx]['PC_REP_EST_COST'] = +servData.PCSS_SERVICE_PREM;
                                jobData['PC_REP_LIST'][indx]['PC_REP_CURR_COST'] = +servData.PCSS_SERVICE_PREM;
                            }
                        }
                    }
                }
                break;
            case 'PC_REP_DISCOUNT':
                jobData['PC_REP_LIST'][indx][fieldName] = evnt.target.value;
                myPercentage = evnt.target.value / 100;
                myBalance = jobData['PC_REP_LIST'][indx]['PC_REP_EST_COST'] * myPercentage;
                fakeBalance = jobData['PC_REP_LIST'][indx]['PC_REP_EST_COST'] - myBalance;
                jobData['PC_REP_LIST'][indx]['PC_REP_CURR_COST'] = fakeBalance;
                break;
            case 'PC_REP_EST_COST':
                jobData['PC_REP_LIST'][indx][fieldName] = evnt.target.value;
                jobData['PC_REP_LIST'][indx]['PC_REP_CURR_COST'] = evnt.target.value;
                jobData['PC_REP_LIST'][indx]['PC_REP_DISCOUNT'] = 0;
                break;
            default:
                jobData['PC_REP_LIST'][indx][fieldName] = evnt.target.value;
                break;
        }
        let subTotals = subtotal(jobData['PC_REP_LIST']);
        jobData['PC_REP_TOTAL_COST'] = subTotals.toString();
        jobData['PC_REP_REM_BAL'] = round2(subTotals - jobData['PC_REP_DEP']).toString();
        this.setState({ jobData });
    }

    handleRemoveService(indx) {
        let { jobData } = this.state;
        jobData['PC_REP_LIST'].splice(indx, 1);
        this.setState({ jobData });
    }

    async handleChange(fieldName, evnt) {
        let { jobData } = this.state;
        switch (fieldName) {
            case 'PC_REP_TYPE':
                jobData[fieldName] = evnt;
                let deviceBrand = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/PCGetDeviceBrand.php`, { DEVICE: evnt.value });
                let RepairModelList = [];
                if (deviceBrand.data.success === 1) {
                    let devices = deviceBrand.data.data;
                    for (let i = 0; i < devices.length; i++) {
                        RepairModelList.push({ value: devices[i].DEVICE_BRAND, label: devices[i].DEVICE_BRAND });
                    }
                }
                jobData['PC_REP_MODEL'] = "";
                jobData['PC_REP_BRAND'] = "";
                jobData['PC_REP_IMSR'] = "";
                jobData['PC_REP_PROB'] = [];
                this.setState({ RepairModelList });
                break;
            case 'PC_REP_MODEL':
                jobData[fieldName] = evnt;
                let deviceType = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/PCGetDeviceName.php`, { BRAND: evnt.value, DEVICE: jobData['PC_REP_TYPE']?.value });
                let RepairBrandList = [];
                if (deviceType.data.success === 1) {
                    let devices = deviceType.data.data;
                    for (let i = 0; i < devices.length; i++) {
                        RepairBrandList.push({ value: devices[i].DEVICE_NAME, label: devices[i].DEVICE_NAME });
                    }
                }
                jobData['PC_REP_BRAND'] = "";
                jobData['PC_REP_IMSR'] = "";
                jobData['PC_REP_LIST'] = [];
                this.setState({ RepairBrandList });
                break;
            case 'PC_REP_BRAND':
            case 'PC_REP_SHOP':
                jobData[fieldName] = evnt;
                break;
            default:
                jobData[fieldName] = evnt.target.value;
                break;
        }
        this.setState({ jobData });
    }

    render() {
        const { jobData } = this.state;

        return (
            <section style={{ padding: 'clamp(24px, 5%, 48px)' }}>
                {!this.state.enableReport ? (
                    <div>
                        {/* ── Custom Stepper ── */}
                        <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '44px', overflowX: 'auto', paddingBottom: '4px' }}>
                            {steps.map((label, index) => (
                                <React.Fragment key={index}>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: '72px' }}>
                                        <div style={{
                                            width: '44px', height: '44px', borderRadius: '50%', flexShrink: 0,
                                            background: index < this.state.activeStep
                                                ? 'linear-gradient(135deg, #c61515, #780e0f)'
                                                : index === this.state.activeStep
                                                    ? 'linear-gradient(135deg, #c61515, #780e0f)'
                                                    : 'rgba(255,255,255,0.05)',
                                            border: index === this.state.activeStep
                                                ? '2px solid rgba(198,21,21,0.5)'
                                                : index < this.state.activeStep
                                                    ? '2px solid #c61515'
                                                    : '2px solid rgba(255,255,255,0.07)',
                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                            boxShadow: index === this.state.activeStep ? '0 0 22px rgba(198,21,21,0.4)' : 'none',
                                        }}>
                                            {index < this.state.activeStep
                                                ? <span style={{ color: 'white', fontSize: '17px', lineHeight: 1 }}>✓</span>
                                                : <span style={{ color: index === this.state.activeStep ? 'white' : '#2e2e2e', fontSize: '13px', fontWeight: '800', fontFamily: 'Catamaran, sans-serif' }}>{index + 1}</span>
                                            }
                                        </div>
                                        <span style={{
                                            marginTop: '9px', fontSize: '10px', fontWeight: '700',
                                            letterSpacing: '0.5px', textAlign: 'center', lineHeight: '1.3',
                                            color: index === this.state.activeStep ? 'white' : index < this.state.activeStep ? '#c61515' : '#2e2e2e',
                                            whiteSpace: 'nowrap',
                                        }}>
                                            {label}
                                        </span>
                                    </div>
                                    {index < steps.length - 1 && (
                                        <div style={{
                                            flex: 1, height: '2px', marginTop: '22px',
                                            marginLeft: '6px', marginRight: '6px',
                                            background: index < this.state.activeStep
                                                ? 'linear-gradient(90deg, #c61515, #780e0f)'
                                                : 'rgba(255,255,255,0.07)',
                                            borderRadius: '2px',
                                        }} />
                                    )}
                                </React.Fragment>
                            ))}
                        </div>

                        {/* ── Step Content ── */}
                        <div style={{ minHeight: '280px' }}>

                            {/* Step 0 — Setup Device */}
                            {this.state.activeStep === 0 && (
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '20px' }}>
                                    <div>
                                        <label style={lbl}>Device Type</label>
                                        <Select
                                            styles={darkSelect}
                                            options={RepairTypeList}
                                            value={jobData['PC_REP_TYPE']}
                                            onChange={this.handleChange.bind(this, 'PC_REP_TYPE')}
                                            placeholder="Select device..."
                                        />
                                    </div>
                                    <div>
                                        <label style={lbl}>Brand</label>
                                        <Select
                                            styles={darkSelect}
                                            options={this.state.RepairModelList}
                                            value={jobData['PC_REP_MODEL']}
                                            onChange={this.handleChange.bind(this, 'PC_REP_MODEL')}
                                            placeholder="Select brand..."
                                        />
                                    </div>
                                    <div>
                                        <label style={lbl}>Model</label>
                                        <Select
                                            styles={darkSelect}
                                            options={this.state.RepairBrandList}
                                            value={jobData['PC_REP_BRAND']}
                                            onChange={this.handleChange.bind(this, 'PC_REP_BRAND')}
                                            placeholder="Select model..."
                                        />
                                    </div>
                                    <div>
                                        <label style={lbl}>Phone Shop</label>
                                        <CreatableSelect
                                            styles={darkSelect}
                                            value={jobData['PC_REP_SHOP']}
                                            options={this.state.RepairShopList}
                                            onChange={this.handleChange.bind(this, 'PC_REP_SHOP')}
                                            placeholder="Select shop..."
                                        />
                                    </div>
                                </div>
                            )}

                            {/* Step 1 — Services */}
                            {this.state.activeStep === 1 && (
                                <div>
                                    {/* Table header */}
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 150px 110px 44px', gap: '10px', marginBottom: '12px', padding: '0 4px' }}>
                                        <span style={{ color: '#444', fontSize: '10px', fontWeight: '700', letterSpacing: '1.5px', textTransform: 'uppercase' }}>Repair</span>
                                        <span style={{ color: '#444', fontSize: '10px', fontWeight: '700', letterSpacing: '1.5px', textTransform: 'uppercase' }}>Service Type</span>
                                        <span style={{ color: '#444', fontSize: '10px', fontWeight: '700', letterSpacing: '1.5px', textTransform: 'uppercase' }}>Cost</span>
                                        <button
                                            onClick={this.handleAddService.bind(this)}
                                            style={{ width: '36px', height: '36px', background: 'rgba(198,21,21,0.12)', border: '1px solid rgba(198,21,21,0.3)', borderRadius: '8px', color: '#c61515', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0, flexShrink: 0 }}
                                        >
                                            <AddIcon style={{ fontSize: '18px' }} />
                                        </button>
                                    </div>

                                    {/* Empty state */}
                                    {jobData['PC_REP_LIST'].length === 0 && (
                                        <div style={{ textAlign: 'center', padding: '36px 24px', background: 'rgba(255,255,255,0.02)', border: '1px dashed rgba(255,255,255,0.07)', borderRadius: '12px', marginBottom: '20px' }}>
                                            <div style={{ color: '#c61515', fontSize: '24px', marginBottom: '10px' }}>+</div>
                                            <p style={{ color: '#3a3a3a', fontSize: '13px', margin: 0 }}>
                                                Click <span style={{ color: '#c61515', fontWeight: '700' }}>+</span> above to add a repair service
                                            </p>
                                        </div>
                                    )}

                                    {/* Service rows */}
                                    {jobData['PC_REP_LIST'].map((elem, indx) => (
                                        <div
                                            key={indx}
                                            style={{ display: 'grid', gridTemplateColumns: '1fr 150px 110px 44px', gap: '10px', marginBottom: '10px', alignItems: 'center', background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: '10px', padding: '12px' }}
                                        >
                                            <Select
                                                menuPortalTarget={document.body}
                                                styles={portalSelect}
                                                options={this.state.RepairServiceList}
                                                value={elem.PC_REP_PROB}
                                                onChange={this.handleChangeServices.bind(this, indx, "PC_REP_PROB")}
                                                placeholder="Select repair..."
                                            />
                                            <Select
                                                menuPortalTarget={document.body}
                                                styles={portalSelect}
                                                options={ServiceTypeOption}
                                                value={elem.PC_REP_SER_TYPE}
                                                onChange={this.handleChangeServices.bind(this, indx, "PC_REP_SER_TYPE")}
                                            />
                                            <input
                                                disabled
                                                readOnly
                                                value={`£${formatAmount(elem.PC_REP_CURR_COST)}`}
                                                style={{ ...inp, background: 'rgba(198,21,21,0.06)', color: '#c61515', fontWeight: '800', cursor: 'default' }}
                                            />
                                            <button
                                                onClick={this.handleRemoveService.bind(this, indx)}
                                                style={{ width: '36px', height: '36px', background: 'rgba(255,80,80,0.08)', border: '1px solid rgba(255,80,80,0.15)', borderRadius: '8px', color: '#ff6060', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0, flexShrink: 0 }}
                                            >
                                                <RemoveIcon style={{ fontSize: '18px' }} />
                                            </button>
                                        </div>
                                    ))}

                                    {/* Total */}
                                    {jobData['PC_REP_LIST'].length > 0 && (
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '8px 0 20px' }}>
                                            <div style={{ background: 'rgba(198,21,21,0.08)', border: '1px solid rgba(198,21,21,0.2)', borderRadius: '10px', padding: '10px 22px', display: 'flex', gap: '14px', alignItems: 'center' }}>
                                                <span style={{ color: '#666', fontSize: '10px', fontWeight: '700', letterSpacing: '1.5px', textTransform: 'uppercase' }}>Total</span>
                                                <span style={{ color: '#c61515', fontSize: '22px', fontWeight: '900', fontFamily: 'Catamaran, sans-serif' }}>£{formatAmount(jobData['PC_REP_TOTAL_COST'])}</span>
                                            </div>
                                        </div>
                                    )}

                                    <div>
                                        <label style={lbl}>Other Information</label>
                                        <textarea
                                            value={jobData['PC_REP_OTHER_INFO']}
                                            onChange={this.handleChange.bind(this, "PC_REP_OTHER_INFO")}
                                            style={{ ...inp, minHeight: '80px', resize: 'vertical' }}
                                            placeholder="Any additional details about the repair..."
                                        />
                                    </div>
                                </div>
                            )}

                            {/* Step 2 — Appointment */}
                            {this.state.activeStep === 2 && (
                                <div style={{ maxWidth: '500px' }}>
                                    <p style={{ color: '#555', fontSize: '13px', marginBottom: '28px', lineHeight: '1.7', margin: '0 0 28px' }}>
                                        Choose a convenient date and time for your repair appointment.
                                    </p>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                                        <div>
                                            <label style={lbl}>Appointment Date</label>
                                            <input
                                                type="date"
                                                value={jobData['PC_REP_APP_DATE']}
                                                onChange={this.handleChange.bind(this, "PC_REP_APP_DATE")}
                                                style={inp}
                                            />
                                        </div>
                                        <div>
                                            <label style={lbl}>Appointment Time</label>
                                            <input
                                                type="time"
                                                value={jobData['PC_REP_APP_TIME']}
                                                onChange={this.handleChange.bind(this, "PC_REP_APP_TIME")}
                                                style={inp}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Step 3 — Personal Info */}
                            {this.state.activeStep === 3 && (
                                <div>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '18px', marginBottom: '18px' }}>
                                        <div>
                                            <label style={lbl}>First Name</label>
                                            <input value={jobData['PC_CUST_FR_NAME']} onChange={this.handleChange.bind(this, "PC_CUST_FR_NAME")} style={inp} placeholder="John" />
                                        </div>
                                        <div>
                                            <label style={lbl}>Last Name</label>
                                            <input value={jobData['PC_CUST_LT_NAME']} onChange={this.handleChange.bind(this, "PC_CUST_LT_NAME")} style={inp} placeholder="Smith" />
                                        </div>
                                        <div>
                                            <label style={lbl}>Phone</label>
                                            <input value={jobData['PC_CUST_PHONE']} onChange={this.handleChange.bind(this, "PC_CUST_PHONE")} style={inp} placeholder="07XXX XXXXXX" />
                                        </div>
                                        <div>
                                            <label style={lbl}>Email</label>
                                            <input type="email" value={jobData['PC_CUST_EMAIL']} onChange={this.handleChange.bind(this, "PC_CUST_EMAIL")} style={inp} placeholder="john@example.com" />
                                        </div>
                                        <div>
                                            <label style={lbl}>House No. / Street</label>
                                            <input value={jobData['PC_CUST_HSST_NO']} onChange={this.handleChange.bind(this, "PC_CUST_HSST_NO")} style={inp} placeholder="42 Baker Street" />
                                        </div>
                                        <div>
                                            <label style={lbl}>Post Code</label>
                                            <input value={jobData['PC_CUST_POST_CODE']} onChange={this.handleChange.bind(this, "PC_CUST_POST_CODE")} style={inp} placeholder="ST1 1NS" />
                                        </div>
                                    </div>
                                    <div>
                                        <label style={lbl}>Additional Information</label>
                                        <textarea
                                            value={jobData['PC_CUST_ADD_INFO']}
                                            onChange={this.handleChange.bind(this, "PC_CUST_ADD_INFO")}
                                            style={{ ...inp, minHeight: '80px', resize: 'vertical' }}
                                            placeholder="Any extra notes about your device or the issue..."
                                        />
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* ── Navigation ── */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '36px', paddingTop: '24px', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
                            <button
                                disabled={this.state.activeStep === 0}
                                onClick={this.handleBackStep.bind(this)}
                                style={{
                                    background: 'transparent',
                                    border: '1px solid ' + (this.state.activeStep === 0 ? 'rgba(255,255,255,0.04)' : 'rgba(255,255,255,0.12)'),
                                    color: this.state.activeStep === 0 ? '#252525' : '#666',
                                    borderRadius: '10px',
                                    padding: '11px 28px',
                                    fontSize: '12px',
                                    fontWeight: '800',
                                    letterSpacing: '1.5px',
                                    textTransform: 'uppercase',
                                    cursor: this.state.activeStep === 0 ? 'not-allowed' : 'pointer',
                                    fontFamily: 'Catamaran, sans-serif',
                                }}
                            >
                                ← Back
                            </button>
                            <span style={{ color: '#2e2e2e', fontSize: '12px', fontWeight: '700', fontFamily: 'Catamaran, sans-serif' }}>
                                {this.state.activeStep + 1} / {steps.length}
                            </span>
                            <button
                                onClick={this.handleNextStep.bind(this)}
                                style={{
                                    background: 'linear-gradient(135deg, #c61515, #780e0f)',
                                    border: 'none',
                                    color: 'white',
                                    borderRadius: '10px',
                                    padding: '11px 32px',
                                    fontSize: '12px',
                                    fontWeight: '800',
                                    letterSpacing: '1.5px',
                                    textTransform: 'uppercase',
                                    cursor: 'pointer',
                                    fontFamily: 'Catamaran, sans-serif',
                                    boxShadow: '0 4px 20px rgba(198,21,21,0.3)',
                                }}
                            >
                                {this.state.activeStep === steps.length - 1 ? 'Submit Booking →' : 'Next →'}
                            </button>
                        </div>
                    </div>
                ) : (
                    <div>
                        <ShowReport
                            REPAIR_TYPE={jobData.PC_REP_TYPE}
                            REPAIR_DEVICE={jobData.PC_REP_BRAND}
                            REPAIR_SHOP={jobData.PC_REP_SHOP}
                            REPAIR_DATE={jobData.PC_REP_APP_DATE}
                            REPAIR_TIME={jobData.PC_REP_APP_TIME}
                            PR_FIRST_NAME={jobData.PC_CUST_FR_NAME}
                            PR_PHONE={jobData.PC_CUST_PHONE}
                            PR_LAST_NAME={jobData.PC_CUST_LT_NAME}
                            PR_EMAIL={jobData.PC_CUST_EMAIL}
                        />
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '24px', paddingTop: '24px', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
                            <button
                                onClick={this.handleRequestMore.bind(this)}
                                style={{
                                    background: 'linear-gradient(135deg, #c61515, #780e0f)',
                                    border: 'none',
                                    color: 'white',
                                    borderRadius: '10px',
                                    padding: '12px 36px',
                                    fontSize: '12px',
                                    fontWeight: '800',
                                    letterSpacing: '1.5px',
                                    textTransform: 'uppercase',
                                    cursor: 'pointer',
                                    fontFamily: 'Catamaran, sans-serif',
                                    boxShadow: '0 4px 20px rgba(198,21,21,0.3)',
                                }}
                            >
                                Book Another Repair
                            </button>
                        </div>
                    </div>
                )}
            </section>
        );
    }
}

export default RepairBlock;
